import { render, staticRenderFns } from "./RegistrationConfirmModule.vue?vue&type=template&id=3986de64&scoped=true&"
import script from "./RegistrationConfirmModule.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirmModule.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationConfirmModule.vue?vue&type=style&index=0&id=3986de64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986de64",
  null
  
)

export default component.exports